import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { DeviceDetectionService } from '../services/device-detection.service';

export const mobileOnlyGuard: CanActivateFn = (route, state) => {
  const deviceDetectionService = inject(DeviceDetectionService);
  const router = inject(Router);
  
  const isMobile = deviceDetectionService.getDeviceInfo().isMobile;
  
  if (!isMobile) router.navigate(['/']);
  return isMobile;
};
